import { Typography } from '@mui/material'
import React from 'react'

export default function PageTitle({ children, sx, ...props }) {
	return (
		<Typography
			variant="h2"
			textAlign="left"
			sx={{
				fontSize: '32pt',
				lineHeight: '42pt',
				marginBottom: '24px',
				maxWidth: '500px',
				...sx,
			}}
			{...props}
		>
			{children}
		</Typography>
	)
}
